<template>
  <div class="content">
    <ed-title-nav
      :title="$t('Payments')"
      :subtitle="$t('Manage Invoices & Payments')"
      :tabs="tabs"
    ></ed-title-nav>
    <legacy-container :url="url"></legacy-container>
  </div>
</template>

<script>
  import tabs from '@/components/_modules/Invoices/tabs'
  import LegacyContainer from '@/components/LegacyContainer'

  export default {
    components: {
      LegacyContainer
    },
    data() {
      return {
        tabs: tabs.tabs
      }
    },
    computed: {
      url() {
        return 'PaymentInvoice/RemitPayment/' + this.$router.currentRoute.params.action
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/suppliers-remit-payment.vue